import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslations from './en.json';
import frTranslations from './fr.json';
import arTranslations from './ar.json'

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslations },
      fr: { translation: frTranslations },
      ar: { translation: arTranslations },

    },
    lng: 'fr', // Default language
    fallbackLng: 'fr', // Fallback language
    interpolation: { escapeValue: false },
  });

export default i18n;
